[
 {
  "id": "panel",
  "x": 86,
  "y": 504,
  "w": 772,
  "h": 860
 }
]